module.exports = __webpack_public_path__ + "static/img/01.b1ad467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news21/01.png
// module id = nwQE
// module chunks = 1